import React from "react";
import Checkbox from "./elements/Checkbox";
import Input from "./elements/Input";
import Password from "./elements/Password";
import Date from "./elements/Date";
import Time from "./elements/Time";
import CustomSelect from "./elements/Select";
import Daypicker from "./elements/Daypicker";
import Numberinput from "./elements/NumberInput";
import FileInput from "./elements/File";
import Header from "./elements/Header";
import Radio from "./elements/Radio";
import Textarea from "./elements/Textarea";

export interface FieldProps {
  allfields_category?: string;
  allfields_code?: string;
  allfields_id?: string;
  allfields_key?: string;
  type: string;
  id: string;
  label?: string | null;
  placeholder?: string;
  value?: any;
  options?: any;
  example?: any;
  disabled?: boolean;
  hidden?: boolean;
  pivot?: boolean;
  pivotreverse?: boolean;
  width?: number;
  category?: string;
  mandatory?: boolean;
  approval?: boolean;
  show?: boolean;
  source?: boolean;
  radiogroup?:string;
  margins?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  fileTypes?: string;
}

export interface ElementProps {
  field: FieldProps;
  md?: number;
}

const Element: React.FC<ElementProps> = ({
  field: {
    type,
    id,
    label,
    placeholder,
    value,
    options,
    example,
    disabled,
    hidden,
    pivot,
    pivotreverse,
    width,
    category,
    mandatory,
    approval,
    show,
    margins,
    fileTypes
  },
  md,
}) => {
  const source = false;
  const defaultMargins = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5,
  };

  const fieldProps = {
    id,
    source,
    label,
    placeholder,
    value,
    example,
    disabled,
    hidden,
    mandatory,
    fileTypes,
    md: md ?? width,
    margins: margins ?? defaultMargins,
  };

  switch (type) {
    case "text":
      return <Input {...fieldProps} />;
    case "textarea":
      return <Textarea {...fieldProps} />;
    case "password":
      return <Password {...fieldProps} />;
    case "select":
      return <CustomSelect {...fieldProps} options={options} />;
    case "date":
      return <Date {...fieldProps} />;
    case "time":
      return <Time {...fieldProps} />;
    case "checkbox":
      return (
        <Checkbox
          {...fieldProps}
          pivot={pivot}
          pivotreverse={pivotreverse}
          approval={approval}
          show={show}
        />
      );
    case "daypicker":
      return <Daypicker {...fieldProps} placeholder={placeholder || ""} />;
    case "numberinput":
      return <Numberinput {...fieldProps} placeholder={placeholder || ""} />;
    case "file":
      return <FileInput {...fieldProps} placeholder={placeholder || ""} />;
    case "radio":
      return (
        <Radio {...fieldProps} pivot={pivot} pivotreverse={pivotreverse} />
      );
    case "header":
      return <Header {...fieldProps} category={category} />;
    default:
      return null;
  }
};

export default Element;
